// extracted by mini-css-extract-plugin
module.exports = {"grid":"PromoCards_grid__nGZRT","card":"PromoCards_card__cRz6y","content":"PromoCards_content__x_lSG","title":"PromoCards_title__kwywU","icon":"PromoCards_icon__jmZdG"};